import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { usePrefs } from 'wsm-common-data';
import { Iframe } from 'wsm-iframe';

/**
 * A frame container.
 * @param {Object} props The component props.
 * @param {string} props.sourceUrl The frame source URL. This value is parsed,
 * 	encoded and dispatched in the server store.
 */
const WidgetContainer = ({ sourceUrl }) => (
	<Iframe {...usePrefs()} src={sourceUrl} encode={false} />
);

WidgetContainer.propTypes = {
	sourceUrl: PropTypes.string.isRequired
};

const mapStateToProps = (state) => ({ sourceUrl: state.sourceUrl });
const mapDispatchToProps = (_dispatch) => ({});
const Widget = connect(mapStateToProps, mapDispatchToProps)(WidgetContainer);

export default Widget;
